export default __webpack_public_path__ + "static/media/dragon_6.2ed7df51.mp3";